import { render, staticRenderFns } from "./EventPersonalization.vue?vue&type=template&id=6f3e6af9&scoped=true"
import script from "./EventPersonalization.vue?vue&type=script&lang=js"
export * from "./EventPersonalization.vue?vue&type=script&lang=js"
import style0 from "./EventPersonalization.vue?vue&type=style&index=0&id=6f3e6af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e6af9",
  null
  
)

export default component.exports